import PropTypes from 'prop-types'
import React, { useEffect, useState } from "react"
import {Container, Row, Col, Button, Card, CardBody, Label, FormGroup, InputGroup} from "reactstrap"
import { Link } from "react-router-dom"
import Flatpickr from "react-flatpickr"
import moment from "moment"
import LineAreaChart from "../AllCharts/apex/lineareachart"
import RadialChart from "../AllCharts/apex/apexdonut"
import Apexdonut from "../AllCharts/apex/apexdonut1"
import SparkLine from "../AllCharts/sparkline/sparkline"
import "chartist/dist/scss/chartist.scss"
import * as url from "../../helpers/url_helper"
import { withTranslation } from "react-i18next"

const Dashboard = () => {
  document.title = "AMAVIE | Tableau de bord"
  const [menu, setMenu] = useState(false)
  const [from, setFrom]= useState(moment().format("YYYY-MM-DD"))
  const [to, setTo]= useState(moment().format("YYYY-MM-DD"))
  const [countAtt, setCountAtt]= useState(0)
  const [countClt, setCountClt]= useState(0)
  const [sumAtt, setSumAtt]= useState(0)
  const [thisMonthSumAtt, setThisMonthSumAtt]= useState(0)
  const [lastMonthSumAtt, setLastMonthSumAtt]= useState(0)
  const [sumBydest, setSumBydest]= useState([])
  const [sumBymonth, setSumBymonth]= useState([])
  const [sumByperiod, setSumByperiod]= useState([])
  const [attestations, setAttestations]= useState([])

  const firstDayOfMonth= moment().startOf('month').format('YYYY-MM-DD')
  const lastDayOfMonth= moment().endOf('month').format('YYYY-MM-DD')
  const firstDayLastMonth= moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
  const lastDayLastMonth= moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')

  const loadCount=()=> {
      fetch(`${url.BACKEND_URL}/attestations/count?start=${from}&end=${to}&user=${JSON.parse(localStorage.getItem("authUser")).id}`, {
        method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.status==200) { setCountAtt(responseJson.data) }
      }) .catch(() => {  })
    }

  const loadSum=()=> {
      fetch(`${url.BACKEND_URL}/attestations/sum?start=${from}&end=${to}&user=${JSON.parse(localStorage.getItem("authUser")).id}`, {
        method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.status==200) { setSumAtt(responseJson.data) }
      }) .catch(() => {  })
    }

  const loadSumByMonth=()=> {
      fetch(`${url.BACKEND_URL}/attestations/sum-by-month?user=${JSON.parse(localStorage.getItem("authUser")).id}`, {
        method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.status==200) { setSumBymonth(responseJson.data) }
      }) .catch(() => {  })
    }

  const loadSumByDestination=()=> {
      fetch(`${url.BACKEND_URL}/attestations/sum-by-destination?user=${JSON.parse(localStorage.getItem("authUser")).id}`, {
        method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.status==200) { setSumBydest(responseJson.data) }
      }) .catch(() => {  })
    }

  const loadSumByPeriod=()=> {
      fetch(`${url.BACKEND_URL}/attestations/sum-by-period?user=${JSON.parse(localStorage.getItem("authUser")).id}`, {
        method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.status==200) { setSumByperiod(responseJson.data) }
      }) .catch(() => {  })
    }

  const loadSumThisMonth=()=> {
      fetch(`${url.BACKEND_URL}/attestations/sum?start=${firstDayOfMonth}&end=${lastDayOfMonth}&user=${JSON.parse(localStorage.getItem("authUser")).id}`, {
        method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.status==200) { setThisMonthSumAtt(responseJson.data) }
      }) .catch(() => {  })
    }

  const loadSumLastMonth=()=> {
      fetch(`${url.BACKEND_URL}/attestations/sum?start=${firstDayLastMonth}&end=${lastDayLastMonth}&user=${JSON.parse(localStorage.getItem("authUser")).id}`, {
        method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.status==200) { setLastMonthSumAtt(responseJson.data) }
      }) .catch(() => {  })
    }

  const loadCountClient=()=> {
      fetch(`${url.BACKEND_URL}/users/count?start=${from}&end=${to}`, {
        method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.status==200) { setCountClt(responseJson.data) }
      }) .catch(() => {  })
    }

  const loadLastAttestation=()=> {
      fetch(`${url.BACKEND_URL}/attestations?user=${JSON.parse(localStorage.getItem("authUser")).id}&size=10`, {
        method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.status==200) { setAttestations(responseJson.data) } else{ setAttestations([])}
      }) .catch(() => {  })
    }
  
    const loadStats= ()=>{
      loadCount()
      loadSum()
      loadCountClient()
      loadSumLastMonth()
      loadSumThisMonth()
      loadLastAttestation()
    }

    useEffect(()=>{ loadStats(), loadSumByMonth(), loadSumByDestination(), loadSumByPeriod()}, [])
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Dashboard</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">Bienvenue sur AMAVIE</li>
                </ol>
              </Col>

            </Row>
          </div>
          <Row>
            <Col md={3}>
              <FormGroup className="form-group mb-3">
                <Label>à partir de</Label>
                <InputGroup className="">
                  <Flatpickr
                    className="form-control d-block"
                    placeholder="Date de début"
                    value={from}
                    options={{ altInput: true, altFormat: "Y-m-d", dateFormat: "Y-m-d" }}
                    onChange={(date, dateStr) => { setFrom(dateStr)}}
                  />
                </InputGroup>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup className="form-group mb-3">
                <Label>jusqu&apos;à</Label>
                <InputGroup className="">
                  <Flatpickr
                    className="form-control d-block"
                    placeholder="Date de fin"
                    value={to}
                    options={{ altInput: true, altFormat: "Y-m-d", dateFormat: "Y-m-d" }}
                    onChange={(date, dateStr) => {setTo(dateStr)}}
                  />
                </InputGroup>
              </FormGroup>
            </Col>
            <Col md={3}>
              <div className="mb-3">
                <Label style={{ visibility: "hidden" }}>--</Label>
                <Button color="primary" className="form-control btn btn-primary waves-effect waves-light" onClick={()=>loadStats()}><i className="fas fa-chart-bar"></i> Filtrer</Button>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xl={4} md={6}>
              <Card className="mini-stat bg-primary text-white">
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <i className='far fa-file-alt' style={{fontSize: 26}}></i>
                    </div>
                    <h5 className="font-size-16 text-uppercase mt-0 text-white-50">Attestations</h5>
                    <h4 className="fw-medium font-size-24">{countAtt}</h4>
                  </div>
                  <div className="pt-2">
                    <div className="float-end">
                      <Link to="#" className="text-white-50">
                        <i className="mdi mdi-arrow-right h5"></i>
                      </Link>
                    </div>
                    <p className="text-white-50 mb-0 mt-1">Attestations vendues</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={4} md={6}>
              <Card className="mini-stat bg-primary text-white">
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <i className='fas fa-money-check' style={{fontSize: 26}}></i>
                    </div>
                    <h5 className="font-size-16 text-uppercase mt-0 text-white-50">Revenue</h5>
                    <h4 className="fw-medium font-size-24">{(sumAtt).toLocaleString("fr-FR")} FCFA</h4>
                    {/* <div className="mini-stat-label bg-danger">
                      <p className="mb-0">- 28%</p>
                    </div> */}
                  </div>
                  <div className="pt-2">
                    <div className="float-end">
                      <Link to="#" className="text-white-50"><i className="mdi mdi-arrow-right h5"></i></Link>
                    </div>

                    <p className="text-white-50 mb-0 mt-1">Revenu global</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={4} md={6}>
              <Card className="mini-stat bg-primary text-white">
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <i className='fas fa-user-tie' style={{fontSize: 26}}></i>
                    </div>
                    <h5 className="font-size-16 text-uppercase mt-0 text-white-50">Clients</h5>
                    <h4 className="fw-medium font-size-24">{countClt}</h4>
                  </div>
                  <div className="pt-2">
                    <div className="float-end">
                      <Link to="#" className="text-white-50">
                        <i className="mdi mdi-arrow-right h5"></i>
                      </Link>
                    </div>

                    <p className="text-white-50 mb-0 mt-1">Clients enregistrés</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xl={9}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Evolution mensuelle</h4>
                  <Row>
                    <Col lg={7}>
                      <div>
                        <LineAreaChart data={sumBymonth} />
                      </div>
                    </Col>
                    <Col lg={5}>
                      <Row>
                        <Col md={6}>
                          <div className="text-center">
                            <p className="text-muted mb-4">Ce mois</p>
                            <h3>{(thisMonthSumAtt).toLocaleString("fr-FR")} FCFA</h3>
                            <RadialChart />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="text-center">
                            <p className="text-muted mb-4">Mois dernier</p>
                            <h3>{(lastMonthSumAtt).toLocaleString("fr-FR")} FCFA</h3>
                            <Apexdonut />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>

            <Col xl={3}>
              <Card>
                <CardBody>
                  <div>
                    <h4 className="card-title mb-4">Attestations par destinations</h4>
                  </div>

                  {sumBydest.map((item)=>(
                  <div key={item.label} className="wid-peity mb-4">
                    <div className="row">
                      <div className="col-md-6">
                        <div>
                          <p className="text-muted">{item.label}</p>
                          <h5 className="mb-4">{(item.sum).toLocaleString("fr-FR")} FCFA</h5>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-4"><SparkLine /></div>
                      </div>
                    </div>
                  </div>
                  ))}
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xl={4}>
              <Card>
                <CardBody>
                  <div>
                    <h4 className="card-title mb-4">Attestations par séjour</h4>
                  </div>

                  {sumByperiod.map((item)=>(
                  <div key={item.label} className="wid-peity mb-4">
                    <div className="row">
                      <div className="col-md-6">
                        <div>
                          <p className="text-muted">{item.label}</p>
                          <h5 className="mb-4">{(item.sum).toLocaleString("fr-FR")} FCFA</h5>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-4">
                          <SparkLine />
                        </div>
                      </div>
                    </div>
                  </div>
                  ))}
                </CardBody>
              </Card>
            </Col>
            <Col xl={8}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Dernières attestations générées</h4>
                  <div className="table-responsive">
                    <table className="table table-hover table-centered table-nowrap mb-0">
                      <thead>
                        <tr>
                          <th scope="col">(#) Référence</th>
                          <th scope="col">Nom</th>
                          <th scope="col">Prénoms</th>
                          <th scope="col">Date</th>
                          <th scope="col">Montant</th>
                          {/* <th scope="col" colSpan="2">
                            Status
                          </th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {attestations.map((item)=>(
                        <tr key={item.reference}>
                          <th scope="row">{item.reference}</th>
                          <td>
                            <div>
                              {item.beneficiaries[0].last_name}
                            </div>
                          </td>
                          <td>
                            <div>
                              {item.beneficiaries[0].first_name}
                            </div>
                          </td>
                          <td>{moment(item.created_date).format("DD-MM-YYYY")}</td>
                          <td><strong>{(item?.tarification?.tarif)?.toLocaleString("fr-FR")} FCFA</strong></td>
                          {/* <td>
                            <span className="badge bg-success">
                              Delivered
                            </span>
                          </td>
                          <td>
                            <div>
                              <Link to="#" className="btn btn-primary btn-sm">
                                Edit
                              </Link>
                            </div>
                          </td> */}
                        </tr>
                         ))}
                        
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any
}

export default withTranslation()(Dashboard)
